<template>
  <v-container fluid class="pb-0">
    <v-row>
      <v-col cols="12" sm="6" md="3" class="pt-0">
        <label class="label">Nome do layout</label>
        <v-text-field v-model="layout.name" class="mt-2" label="Informe do layout" maxlength="70" solo
          :rules="layout.name ? [] : [rule.required]" :disabled="isDisableHeader" />
      </v-col>
      <v-col v-if="isInsuranceCarrier" cols="12" sm="6" md="3" class="pt-0">
        <label class="label">Tipo de Interface</label>
        <v-autocomplete class="mt-2" :items="typeInterfaces" :loading="loadTypeInterfaces" item-text="name"
          item-color="primary" label="Informe o tipo de interface" color="primary" solo
          :disabled="isDisableHeader" />
      </v-col>
      <v-col cols="12" sm="6" md="3" class="pt-0">
        <label class="label">Tipo de Integração*</label>
        <v-autocomplete class="mt-2" :items="typeIntegrations" v-model="typeIntegrationValue" item-text="text"
          item-value="value" item-color="primary" label="Informe o tipo de integração" color="primary"
          :rules="[rule.required]" validate-on-blur clearable solo :disabled="isDisableHeader" />
      </v-col>
      <v-col cols="12" sm="6" md="3" class="pt-0">
        <label class="label">Tipo do Arquivo</label>
        <v-text-field label="Tipo do Arquivo" :value="layout.fileType === 'XLS' ? 'XLSX' : layout.fileType" solo
          class="mt-2" readonly disabled />
      </v-col>
      <v-col cols="12" sm="6" md="3" class="pt-0">
        <label class="label">Tipo do Layout</label>
        <v-text-field class="mt-2" label="Tipo do Layout"
          :value="layout.layoutType === 'NONE' ? 'Nenhum' : layout.layoutType === 'POSITIONAL' ? 'Posicional' : layout.layoutType === 'DELIMITED' ? 'Delimitado' : null"
          solo readonly disabled />
      </v-col>
      <v-col cols="12" sm="6" md="3" class="pt-0">
        <label class="label">Tipo da Entidade*</label>
        <v-autocomplete class="mt-2" :items="[
          { id: 'FINANCIAL_GROUP', name: 'Grupo Financeiro' },
          { id: 'INSURANCE_CARRIER', name: 'Operadora' },
        ]" @change="setLayoutEntityType" v-model="layout.entityType" item-text="name" item-value="id"
          item-color="primary" label="Informe o tipo da entidade" color="primary" :rules="[rule.required]"
          validate-on-blur clearable solo :disabled="isDisableHeader" />
      </v-col>
      <v-col v-if="layout.fileType !== 'XLS'" cols="12" sm="6" md="3" class="pt-0">
        <label class="label">Delimitador</label>
        <v-text-field class="mt-2" label="Delimitador" :value="layout.delimiter" solo readonly disabled />
      </v-col>
    </v-row>

    <ConfirmationModal ref="ConfirmationModal" @confirm="confirmAction" @cancel="cancelAction" :persistent="true"
      :showCloseButton="false" :showCancelButton="showCancelButtonConfirmModal" :cancelLabel="'Cancelar'"
      :confirmLabel="confirmLabelModal" :title="'Atenção'" :description="confirmModalDescription" :color="'primary'" />
  </v-container>
</template>

<script>
import Rules from '@/shared/validators/formRules';
import CollectorIntegrationService from '@/services-http/sdi/CollectorIntegrationService';
import CarrierInterfaceService from '@/services-http/odoo/CarrierInterfaceService';
import FinancialGroupsMixin from '@/shared/mixins/sdi/financialGroupsMixin';
import ContractsMixin from '@/shared/mixins/sdi/contractsMixin';
import InsuranceCarriersMixin from '@/shared/mixins/sdi/insuranceCarriersMixin';
import ConfirmationModal from '@/components/Modals/ConfirmationModal/ConfirmationModal.vue';
import LayoutImportMixin from '@/shared/mixins/layoutImport/layoutImportMixin';
import {
  typeIntegrationValueUpdated,
  typeIntegrationValueConfirmation,
} from '../Columns/columnInfo';
import { mapGetters, mapMutations } from 'vuex';

export default ({

  components: {
    ConfirmationModal,
  },

  data: () => ({
    financialGroups: [],
    contracts: [],
    subContracts: [],
    insuranceCarriers: [],
    typeInterfaces: [],
    collectors: [],
    typeIntegrations: [
      { text: 'Recebimento', value: 'RECEIVEMENT' },
      { text: 'Envio', value: 'SHIPPING' },
      { text: 'Folha', value: 'PAYROLL' },
    ],

    layoutType: {},
    layout: {},

    isEdit: false,
    isCopy: false,
    isFinancialGroup: false,
    isInsuranceCarrier: false,
    isLoadingContract: false,
    isLoadingSubContract: false,

    layoutLoaded: false,
    loadindFinancialGroups: false,
    loadingContracts: false,
    loadingSubContracts: false,
    loadTypeInterfaces: false,
    loadingCollectors: false,
    inConfirmation: false,
    isDisableHeader: false,
    showCancelButtonConfirmModal: true,

    actionType: '',
    confirmLabelModal: 'Prosseguir',
    confirmModalDescription: '',

    oldTypeIntregration: null,
    newTypeIntregration: null,
    typeIntegrationValue: null,
  }),

  watch: {
    layout: {
      deep: true,
      handler(val) {
        if (val) {
          this.$emit('headerConfigurationComponent', val);
        }
      },
    },

    layoutData: {
      deep: true,
      handler(newValue, oldValue) {
        if (Object.keys(oldValue).length === 0) {
          this.loadTypeInterface();
        }
      },
    },

    typeIntegrationValue: {
      handler(newTypeIntregration, oldTypeIntregration) {
        this.$nextTick(() => {
          if (!newTypeIntregration) return;
          if (!this.layoutLoaded) return;
          if (this.inConfirmation) return;

          if (oldTypeIntregration !== newTypeIntregration) {
            this.inConfirmation = true;

            this.confirmUpdateTypeIntegration(
              newTypeIntregration,
              oldTypeIntregration
            );
          }
        });
      }
    }
  },

  mixins: [
    InsuranceCarriersMixin,
    FinancialGroupsMixin,
    LayoutImportMixin,
    ContractsMixin,
  ],

  async mounted() {
    this.routeSpotter();

    if (Object.keys(this.layoutData).length > 0) {
      await this.loadSessionStorage();
    }

    if (this.layout.insuranceCarrierId) {
      this.loadTypeInterface();
    }
  },

  methods: {
    ...mapMutations({
      setLayoutEntityType: 'layout-import/setLayoutEntityType',
      setLayoutType: 'layout-import/setLayoutType',
      setLayoutColumns: 'layout-import/setLayoutColumns',
    }),

    updateTypeIntegration() {
      this.$nextTick(() => {
        this.layout.typeIntegrationValue = this.newTypeIntregration;
        this.typeIntegrationValue = this.newTypeIntregration;

        this.showCancelButtonConfirmModal = false;

        this.actionType = 'confirmTypeIntegrationValue';

        this.confirmModalDescription = typeIntegrationValueUpdated;

        this.confirmLabelModal = 'Ok';

        this.$refs.ConfirmationModal.open();

        this.removeMismatchedIntegrationColumns();
      });
    },

    finishConfirmUpdateTypeIntegration() {
      this.finishTypeIntegrationUpdate();
    },

    cancelTypeIntegrationUpdate() {
      this.layout.typeIntegrationValue = this.oldTypeIntregration;

      this.typeIntegrationValue = this.oldTypeIntregration;

      this.finishTypeIntegrationUpdate();
    },

    confirmUpdateTypeIntegration(newTypeIntregration, oldTypeIntregration) {
      if (
        this.layoutData.columns.length === 0 ||
        this.hasOnlyCommonColumns
      ) {
        this.layout.typeIntegrationValue = newTypeIntregration;
        this.finishAction();
        return;
      }

      this.newTypeIntregration = newTypeIntregration;
      this.oldTypeIntregration = oldTypeIntregration;

      const columnTypeToBeRemoved = this.getRemovedColumnByIntegrationType(
        this.newTypeIntregration
      );

      this.confirmModalDescription = typeIntegrationValueConfirmation(
        columnTypeToBeRemoved.label
      );

      this.actionType = 'typeIntegrationValue';

      this.$refs.ConfirmationModal.open();
    },

    getRemovedColumnByIntegrationType(typeIntregrationValue) {
      switch (typeIntregrationValue) {
        case 'RECEIVEMENT':
          return {
            columnType: 'virtual',
            label: "Virtual"
          };

        case 'SHIPPING':
          return {
            columnType: 'complementary',
            label: "Complementar"
          };

        case 'PAYROLL':
          return {
            columnType: 'all',
            label: "Virtual e Complementar"
          };
      }
    },

    removeMismatchedIntegrationColumns() {
      switch (this.layout.typeIntegrationValue) {
        case 'RECEIVEMENT':
          this.layout.columns = this.layoutData.columns.filter(
            (column) => column.columnType === 'DEFAULT');

          break;

        case 'SHIPPING':
          this.layout.columns = this.layoutData.columns.filter(
            (column) =>
              (
                column.columnType === 'DEFAULT'
                && column.complementaryLayout != true
              ) ||
              (column.columnType === 'VIRTUAL')
          );

          break;

        case 'PAYROLL':
          this.layout.columns = this.layoutData.columns.filter(
            (column) => column.columnType === 'DEFAULT'
              && column.complementaryLayout != true);

          break;
      }

      this.setLayoutColumns(this.layout.columns);
    },

    confirmAction() {
      switch (this.actionType) {
        case 'typeIntegrationValue':
          this.updateTypeIntegration();

          break;

        case 'confirmTypeIntegrationValue':
          this.finishConfirmUpdateTypeIntegration();

          break;
      };
    },

    cancelAction() {
      switch (this.actionType) {
        case 'typeIntegrationValue':
          this.cancelTypeIntegrationUpdate();

          break;
      };
    },

    finishAction() {
      this.actionType = '';
      this.confirmLabelModal = 'Prosseguir';
      this.inConfirmation = false;
      this.showCancelButtonConfirmModal = true;
    },

    finishTypeIntegrationUpdate() {
      setTimeout(() => {
        this.resetTypeIntegrationFields();
        this.finishAction();
      }, 500);
    },

    resetTypeIntegrationFields() {
      this.newTypeIntregration = '';
      this.oldTypeIntregration = '';
    },

    async loadSessionStorage() {
      this.layoutLoaded = false;

      this.layoutType = JSON.parse(JSON.stringify(this.layoutTypeData));
      this.layout = JSON.parse(JSON.stringify(this.layoutData));
      this.financialGroups = this.layoutType.financialGroups;
      this.contracts = this.layoutType.contracts;
      this.subContracts = this.layoutType.subContracts;
      this.insuranceCarriers = this.layoutType.insuranceCarriers;
      this.layout.financialGroupId = this.layoutType.financialGroupId;
      this.layout.insuranceCarrierId = this.layoutType.insuranceCarrierId;
      this.layout.entityType = this.layoutEntityType;

      if (this.layout && this.layout.typeIntegrationValue) {
        this.typeIntegrationValue = this.layout.typeIntegrationValue;
      }

      if (this.layout && this.layout.financialGroupId) {
        this.isFinancialGroup = true;
        if (this.rule.isEmptyArray(this.financialGroups)) await this.getFinancialGroups();
        if (this.rule.isEmptyArray(this.contracts)) await this.getContractsByFinancialGroupId(this.layout.financialGroupId);
        if (this.rule.isEmptyArray(this.subContracts)) await this.getSubContractsByContractId(this.layout.contractId);
        if (!this.isDisableHeader) {
          this.emitHeaderConfigurationEvent();
          this.emitLayoutInfoEvent();
        }
      } else {
        this.isInsuranceCarrier = true;
        if (this.rule.isEmptyArray(this.insuranceCarriers)) await this.getInsuranceCarriers();
      }

      setTimeout(() => {
        this.layoutLoaded = true;
      }, 500);
    },

    requestCollectors(type) {
      if (type === 'change') {
        this.layout.collectorIntegrationConfigId = null;
      }

      this.loadingCollectors = true;
      const queryParams = this.layout.financialGroupId ? `financialGroupId=${this.layout.financialGroupId}` : `insuranceCarrierId=${this.layout.insuranceCarrierId}`;
      let typeIntegrationQueryParam = '';

      if (this.layout.typeIntegrationValue === 'RECEIVEMENT' || this.layout.typeIntegrationValue === 'SHIPPING') {
        typeIntegrationQueryParam = '&type=FTP';
      } else if (this.layout.typeIntegrationValue === 'PAYROLL') {
        typeIntegrationQueryParam = '&type=PAYROLL';
      }

      const queryString = `?${queryParams}${typeIntegrationQueryParam}`;

      this.collectorIntegrationService.FindAllByFilters(queryString).then((response) => {
        this.collectors = response.data.content;
        this.collectors = this.collectors.map((element) => ({
          text: `${element.type}/${element.name}`,
          id: element.id,
        }));
        this.layoutType.collectors = this.collectors;
        this.loadingCollectors = false;
      }).catch(() => {
        this.loadingCollectors = false;
        this.customizeSnackbarMessage('error', 'Ocorreu um erro ao carregar os coletores');
      });
    },

    loadTypeInterface() {
      this.loadTypeInterfaces = true;
      this.carrierInterfaceService.FindAllByCarrierId(this.layout.insuranceCarrierId).then((response) => {
        if (response && response.data.records && response.data.records.length > 0) {
          this.typeInterfaces = response.data.records;
        }
        this.loadTypeInterfaces = false;
      }).catch(() => {
        this.loadTypeInterfaces = false;
        this.customizeSnackbarMessage('error', 'Ocorreu um erro ao carregar os tipos de interfaces');
      });
    },

    routeSpotter() {
      if (this.$route.name === 'LayoutImportColumnEditConfigs' || this.$route.name === 'LayoutImportTransformationEditConfigs') {
        this.isEdit = true;
      } else if (this.$route.name === 'LayoutImportColumnCopyConfigs' || this.$route.name === 'LayoutImportTransformationCopyConfigs') {
        this.isCopy = true;
      }
      this.$emit('isEditControl', this.isEdit);
      this.$emit('isCopyControl', this.isCopy);

      if (this.$route.name === 'LayoutImportTransformationConfigs' || this.$route.name === 'LayoutImportTransformationEditConfigs' || this.$route.name === 'LayoutImportTransformationCopyConfigs') {
        this.isDisableHeader = true;
      }
    },

    emitLayoutTypeEvent() {
      if (!this.rule.isEmptyArray(this.financialGroups) || !this.rule.isEmptyArray(this.contracts) || !this.rule.isEmptyArray(this.subContracts)) {
        this.emitHeaderConfigurationEvent();
        this.emitLayoutInfoEvent();
      }
    },

    emitHeaderConfigurationEvent() {
      this.layout.financialGroupName = this.getFinancialGroupNameById(this.layout.financialGroupId);
      this.layout.contractName = this.getContractNameById(this.layout.contractId);
      this.layout.subContractName = this.getSubContractNameById(this.layout.subContractId);
      this.layout.insuranceCarrierName = this.getInsuranceCarrierNameById(this.layout.insuranceCarrierId);
      this.$emit('headerConfigurationComponent', this.layout);
    },

    emitLayoutInfoEvent() {
      this.layoutType.contracts = this.contracts;
      this.layoutType.subContracts = this.subContracts;
      this.layoutType.financialGroupId = this.layout.financialGroupId;
      this.layoutType.contractId = this.layout.contractId;
      this.layoutType.subContractId = this.layout.subContractId;
      this.layoutType.insuranceCarrierId = this.layout.insuranceCarrierId;
      this.$emit('setLayoutInfoInLayoutType', this.layoutType);
    },

    actionsChangeFinancialGroup() {
      this.layout.contractId = null;
      this.layout.subContractId = null;
      this.layout.collectorIntegrationConfigId = null;
      this.getContractsByFinancialGroupId(this.layout.financialGroupId);
      this.emitLayoutTypeEvent();
    },
  },

  computed: {
    ...mapGetters({
      layoutData: 'layout-import/layout',
      layoutTypeData: 'layout-import/layoutType',
      layoutEntityType: 'layout-import/layoutEntityType',
    })
  },

  created() {
    this.rule = new Rules();
    this.collectorIntegrationService = new CollectorIntegrationService();
    this.carrierInterfaceService = new CarrierInterfaceService();
  },
});
</script>
